export default {"src":"/_next/static/media/bcbsnc.e61e8950.svg","height":48,"width":245,"blurWidth":0,"blurHeight":0};